import React from "react";
import { Route, Redirect } from "react-router-dom";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectCurrentUser } from "../../redux/user/user.selector";

const PublicRoute = (props) => {
  const { component: Component, restricted = false, ...rest } = props;

  const render = ({ currentUser }) => {
    if (currentUser && restricted) {
      return <Redirect to="/" />;
    }

    return <Component {...props} />;
  };

  return <Route {...rest} render={render} />;
};

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
});

export default connect(mapStateToProps)(PublicRoute);
